<div class="container-flude center-content terms-of-use">
    <div class="text-center">
        <h1 class="text-light">Terms of Use Links for our AGI Cargo Partners</h1>
        <ul class="list-unstyled">
            @for (link of links; let linkIndex = $index; track linkIndex) {
                <li>
                    <a [href]="link.href" class="d-block py-2 text-item" target="_blank">{{ link.text }}</a>
                </li>
            }
        </ul>
    </div>
</div>
